import React from 'react';
import { motion } from 'framer-motion';
import { Check, X, Sparkles } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Comparison() {
  const {
    t
  } = useLanguage();
  const rows = [{
    key: 'time',
    ...t.comparison.rows.time
  }, {
    key: 'cost',
    ...t.comparison.rows.cost
  }, {
    key: 'revisions',
    ...t.comparison.rows.revisions
  }, {
    key: 'tech',
    ...t.comparison.rows.tech
  }, {
    key: 'maintenance',
    ...t.comparison.rows.maintenance
  }, {
    key: 'quality',
    ...t.comparison.rows.quality
  }, {
    key: 'scalability',
    ...t.comparison.rows.scalability
  }];
  return <section className="py-32 bg-warm-50 dark:bg-[#050505] transition-colors duration-500" data-id="element-47">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-48">
        <div className="text-center mb-24" data-id="element-49">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6" data-id="element-50">
            {t.comparison.title}
          </motion.h2>
          <p className="text-xl text-gray-600 dark:text-gray-400 max-w-2xl mx-auto" data-id="element-51">
            {t.comparison.subtitle}
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative rounded-3xl overflow-hidden border border-gray-200 dark:border-white/10 shadow-2xl bg-white dark:bg-[#0A0A0A]" data-id="element-52">
          {/* Header */}
          <div className="grid grid-cols-3 border-b border-gray-200 dark:border-white/10" data-id="element-53">
            <div className="p-8 text-sm font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider flex items-center" data-id="element-54">
              {t.comparison.feature}
            </div>
            <div className="p-8 text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider text-center flex items-center justify-center bg-gray-50/50 dark:bg-white/5" data-id="element-55">
              {t.comparison.studio}
            </div>
            <div className="relative p-8 text-sm font-bold text-white uppercase tracking-wider text-center overflow-hidden" data-id="element-56">
              <div className="absolute inset-0 bg-accent-blue dark:bg-blue-600 opacity-90" data-id="element-57" />
              <div className="absolute inset-0 bg-gradient-to-br from-blue-400 to-purple-600 opacity-50" data-id="element-58" />
              <div className="relative z-10 flex items-center justify-center gap-2" data-id="element-59">
                <Sparkles className="w-4 h-4" data-id="element-60" />
                {t.comparison.ai}
              </div>
            </div>
          </div>

          {/* Rows */}
          <div className="divide-y divide-gray-100 dark:divide-white/5" data-id="element-61">
            {rows.map((row, idx) => <div key={idx} className="grid grid-cols-3 group hover:bg-gray-50 dark:hover:bg-white/[0.02] transition-colors duration-300" data-id="element-62">
                <div className="p-8 text-gray-900 dark:text-white font-medium flex items-center" data-id="element-63">
                  {row.name}
                </div>

                <div className="p-8 text-gray-500 dark:text-gray-400 text-center flex items-center justify-center gap-3 bg-gray-50/30 dark:bg-white/[0.02]" data-id="element-64">
                  <div className="w-8 h-8 rounded-full bg-red-100 dark:bg-red-500/10 flex items-center justify-center" data-id="element-65">
                    <X className="w-4 h-4 text-red-500 dark:text-red-400" data-id="element-66" />
                  </div>
                  <span className="hidden md:inline" data-id="element-67">{row.studio}</span>
                </div>

                <div className="relative p-8 text-gray-900 dark:text-white font-bold text-center flex items-center justify-center gap-3" data-id="element-68">
                  {/* Subtle highlight background for AI column */}
                  <div className="absolute inset-0 bg-accent-blue/5 dark:bg-blue-500/5 opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-69" />

                  <div className="relative z-10 flex items-center justify-center gap-3" data-id="element-70">
                    <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow-lg shadow-blue-500/30" data-id="element-71">
                      <Check className="w-4 h-4 text-white" data-id="element-72" />
                    </div>
                    <span className="hidden md:inline bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-purple-600 dark:from-blue-400 dark:to-purple-400" data-id="element-73">
                      {row.ai}
                    </span>
                  </div>
                </div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}